import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getWorkgroups = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/workgroups?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getWorkgroup = async (workgroupId) => {
    const url = `/api/v1/workgroups/${workgroupId}`;
    const res = await axios.get(url);
    return res.data;
}

export const createWorkgroup = async (data) => {
    const url = `/api/v1/workgroups`;
    const res = await axios.post(url, data);
    return res.data;
}

export const updateWorkgroup = async (workgroupId, data) => {
    const url = `/api/v1/workgroups/${workgroupId}`;
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, data[key]);
    }
    const res = await axios.put(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;

}